/**
 * GIF Service - Handles GIPHY API interactions (search, trending, display)
 */
export default class GifService {
    constructor({apiKey, language = "en"}) {
        this.apiKey = apiKey
        this.language = language
        this.searchTimeout = null
    }

    async search(query) {
        if (!this.apiKey) {
            console.warn("GIPHY API key not configured")
            return []
        }

        const url = `https://api.giphy.com/v1/gifs/search?api_key=${this.apiKey}&q=${encodeURIComponent(query)}&limit=20&rating=g&lang=${this.language}`
        return this._fetch(url)
    }

    async trending() {
        if (!this.apiKey) {
            console.warn("GIPHY API key not configured")
            return []
        }

        const url = `https://api.giphy.com/v1/gifs/trending?api_key=${this.apiKey}&limit=20&rating=g&lang=${this.language}`
        return this._fetch(url)
    }

    debouncedSearch(query, callback, delay = 500) {
        if (this.searchTimeout) clearTimeout(this.searchTimeout)

        if (!query) {
            this.trending().then(callback)
            return
        }

        this.searchTimeout = setTimeout(() => {
            this.search(query).then(callback)
        }, delay)
    }

    async downloadAsFile(gifUrl) {
        const response = await fetch(gifUrl)
        const blob = await response.blob()
        return new File([blob], `giphy_${Date.now()}.gif`, {type: "image/gif"})
    }

    async _fetch(url) {
        try {
            const response = await fetch(url)
            const data = await response.json()
            return data.data && data.data.length > 0 ? data.data : []
        } catch (error) {
            console.error("GIF fetch error:", error)
            return []
        }
    }

    renderGifs(gifs, container, actionName) {
        container.innerHTML = ""

        gifs.forEach(gif => {
            const btn = document.createElement("button")
            btn.type = "button"
            btn.className = "relative aspect-square overflow-hidden rounded-lg hover:opacity-80 transition-opacity group"
            btn.dataset.gifUrl = gif.images.fixed_height.url || gif.images.original.url
            btn.dataset.action = actionName

            const img = document.createElement("img")
            img.src = gif.images.fixed_height_small.url || gif.images.fixed_height.url
            img.alt = gif.title || "GIF"
            img.className = "w-full h-full object-cover"
            img.loading = "lazy"

            btn.appendChild(img)
            container.appendChild(btn)
        })
    }
}
